import isArray from 'lodash-es/isArray';
import isObject from 'lodash-es/isObject';
import assign from 'lodash-es/assign';
import * as URI from 'uri-js';
import { get_rpc } from 'cache-store';
export const transportRegistry = new Map();
export const envelopeRegistry = new Map();
function getTarget(smd, method) {
    let dest = smd && smd.url ? smd.url : '';
    if (smd && smd.target) {
        if (dest && dest.length > 0) {
            dest = URI.resolve(dest, smd.target);
        }
        else {
            dest = URI.normalize(smd.target);
        }
    }
    if (method.target) {
        dest = smd && smd.url ? smd.url : '';
        if (dest && dest.length > 0) {
            dest = URI.resolve(dest, method.target);
        }
        else {
            dest = URI.normalize(method.target);
        }
    }
    return dest;
}
export class RpcService {
    _smd;
    _options;
    _requestId;
    _envDef;
    static _nextId = 0;
    constructor(smd, options = {}) {
        this._requestId = 0;
        this._options = options;
        const processSMD = (smd) => {
            this._smd = smd;
            for (const servicename in smd.services) {
                const pieces = servicename.split('.');
                let current = this;
                for (let i = 0; i < pieces.length - 1; i++) {
                    current = current[pieces[i]] || (current[pieces[i]] = {});
                }
                current[pieces[pieces.length - 1]] = this._generateService(servicename, smd.services[servicename]);
            }
        };
        smd && processSMD(smd);
    }
    _generateService(servicename, method) {
        if (this[servicename]) {
            throw new Error(`WARNING: ${servicename} already exists for service. Unable to generate function`);
        }
        method.name = servicename;
        let func = this._executeMethod.bind(this, method);
        const transportName = method.transport || (this._smd && this._smd.transport);
        if (transportName !== undefined) {
            const transport = transportRegistry.get(transportName);
            if (transport && transport.getExecutor) {
                func = transport.getExecutor(func, method, this);
            }
        }
        const schema = method.returns || (method._schema = {});
        const servicepath = `/${servicename}/`;
        schema._service = func;
        func.servicepath = servicepath;
        func._schema = schema;
        func.id = RpcService._nextId++;
        return func;
    }
    _getRequest(method, ...args) {
        const smd = this._smd;
        const envdef = envelopeRegistry.get(method.envelope || (smd && smd.envelope) || 'NONE');
        const parameters = (method.parameters || []).concat((smd && smd.parameters) || []);
        let argvals;
        if (envdef && envdef.namedParams) {
            if (isArray(args[0])) {
                args = args[0];
            }
            if (args.length === 1 && isObject(args[0])) {
                argvals = args[0];
            }
            else {
                const data = {};
                for (let i = 0; i < method.parameters.length; i++) {
                    const params = method.parameters[i];
                    if (params.name && (typeof args[i] !== 'undefined' || !params.optional)) {
                        data[params.name] = args[i];
                    }
                }
                argvals = data;
            }
            if (method.strictParameters || (smd && smd.strictParameters)) {
                for (const i in argvals) {
                    let found = false;
                    for (let j = 0; j < parameters.length; j++) {
                        if (parameters[j].name === i) {
                            found = true;
                        }
                    }
                    if (!found) {
                        delete argvals[i];
                    }
                }
            }
            for (let i = 0; i < parameters.length; i++) {
                const param = parameters[i];
                if (!param.optional && param.name && !argvals[param.name]) {
                    if (param['default']) {
                        argvals[param.name] = param['default'];
                    }
                    else if (!(param.name in argvals)) {
                        throw new Error(`Required parameter ${param.name} was omitted`);
                    }
                }
            }
        }
        else if (parameters && parameters[0] && parameters[0].name && args.length === 1 && isObject(args[0])) {
            if (envdef && envdef.namedParams === false) {
            }
            else {
            }
        }
        const schema = method._schema || method.returns;
        const request = envdef.serialize.apply(this, [smd, method, argvals]);
        request._envDef = envdef;
        const contentType = method.contentType || (smd && smd.contentType) || request.contentType;
        const settings = {
            sync: !!this._options.sync,
            contentType: contentType,
            headers: method.headers || (smd && smd.headers) || request.headers || {},
            target: request.target || getTarget(smd, method),
            transport: method.transport || (smd && smd.transport) || request.transport,
            envelope: method.envelope || (smd && smd.envelope) || request.envelope,
            timeout: method.timeout || (smd && smd.timeout),
            callbackParamName: method.callbackParamName || (smd && smd.callbackParamName),
            rpcObjectParamName: method.rpcObjectParamName || (smd && smd.rpcObjectParamName),
            schema: schema,
            handleAs: request.handleAs || 'auto',
            preventCache: method.preventCache || (smd && smd.preventCache),
            cacheable: method.cacheable || (smd && smd.cacheable),
            cacheLifetime: method.cacheLifetime || (smd && smd.cacheLifetime),
            returnResponseObject: method.returnResponseObject || (smd && smd.returnResponseObject),
            frameDoc: this._options.frameDoc || undefined
        };
        return assign(request, settings);
    }
    async _executeMethod(method, ...args) {
        const request = this._getRequest(method, args);
        const action = () => transportRegistry.get(request.transport).fire(request);
        const promise = get_rpc({ request, action });
        return promise.then((results) => request._envDef.deserialize.call(this, results), (results) => request._envDef.deserialize.call(this, results));
    }
}
